module.exports = ".m-messenger__messages .mCustomScrollbar ._mCS_5 .mCS-autoHide {\n  height: 300px; }\n\n.m-quick-sidebar {\n  top: 150px; }\n\n.m-quick-sidebar-timestamp {\n  text-align: right;\n  margin: 5px;\n  font-size: 11px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sticky-chat/sticky-chat.component.scss
// module id = ./src/app/components/sticky-chat/sticky-chat.component.scss
// module chunks = main